import { Web3ReactProvider } from '@web3-react/core'
import { Connector } from '@web3-react/types'
import { ReactNode, useEffect } from 'react'
import { useAppSelector } from '../helpers/hooks'
import { getConnectorForWallet, injected, network, useConnectors } from './connectors'


const connect = async (connector: Connector) => {
  try {
    if (connector.connectEagerly) {
      await connector.connectEagerly()
    } else {
      await connector.activate()
    }
  } catch (error) {
    console.debug(`web3-react eager connection error: ${error}`)
  }
}

export default function Web3Provider({ children }: { children: ReactNode }) {
  // const selectedWalletBackfilled = useAppSelector(state => state.app.selectedWalletBackfilled)
  const selectedWallet = useAppSelector(state => state.app.selectedWallet)
  const isDesktop = useAppSelector(state => state.app.isDesktop)
  const connectors = useConnectors(selectedWallet)

  const isMetaMask = !!window.ethereum?.isMetaMask
  useEffect(() => {
    connect(network)
    if (!isDesktop && isMetaMask) {
      injected.activate()
    } else if (selectedWallet) {
      connect(getConnectorForWallet(selectedWallet))
    }
  }, [])

  return <Web3ReactProvider connectors={connectors}>{children}</Web3ReactProvider>
}
